<!--
  - Copyright (c) 2021. Trade Research Advisory (Pty) Ltd, P.O.Box 336, Cornwall Hill, Irene, 0178
  - #  This file forms part of the Trade-DSM application frontend.
  - #  https://github.com/Tooblippe/trade-dsm-frontend
  -->

<template>
  <v-main class="trade-background">
    <v-container fluid>
      <v-row class="mt-12">
        <v-col cols="1" sm="1" md="1"></v-col>
        <v-col>
          <v-row align="center">
            <v-col cols="2" md="2">
              <a href="https://tradeadvisory.co.za/" class="black--text" target="_blank">
                <img
                  class="ml-md-0 login_img"
                  src="https://tradeadvisory.co.za/wp-content/uploads/2023/01/TA_Orange_Grey-300x160.png"
                  alt="trade advisory company logo"
                />
              </a>
            </v-col>
            <v-col cols="9" md="9"></v-col>
            <v-col cols="12" lg="4" md="5" class="top-line mt-6">
              <h1 class="h1 font-italic">
                We help you identify
              </h1>
              <h1 class="orange-line font-italic ">
                Realistic Export Opportunities
              </h1>

              <div class="login" v-if="is_compatible_browser()">
                <div class="login-screen">
                  <form>
                    <div class="login-form" v-on:keyup.enter="start_login_process_local">
                      <div v-if="!login_started">
                        <div class="control-group">
                          <label for="username"></label
                          ><input
                            id="username"
                            v-model="username"
                            class="login-field poppins mt-4"
                            placeholder="username"
                            type="text"
                          />
                          <label
                            class="login-field-icon fui-user"
                            for="login-name"
                          ></label>
                        </div>

                        <div class="control-group">
                          <label for="password"></label
                          ><input
                            id="password"
                            v-model="password"
                            autocomplete="on"
                            class="login-field"
                            placeholder="password"
                            type="password"
                          />
                          <label
                            class="login-field-icon fui-lock"
                            for="login-pass"
                          ></label>
                        </div>

                        <v-tooltip bottom :disabled="policy_accepted || (!policy_agree_false_text && !policy_agree_true_text)">
                          <template v-slot:activator="{ on, attrs }">
                            <div v-on="on" v-bind="attrs">
                              <v-btn
                                id="login"
                                color="#f59f26"
                                class="btn btn-large btn-block"
                                :disabled="!policy_accepted && (!!policy_agree_false_text || !!policy_agree_true_text)"
                                @click="start_login_process_local"
                                >LOG IN
                              </v-btn>
                            </div>
                          </template>
                          <span>Please accept the privacy policy below</span>
                        </v-tooltip>

                        <v-checkbox
                          class="shrink mt-1 mb-0 checksize ml-2 text-right poppins top"
                          v-model="clear_casch_selected"
                          label="Clear Cache on Login"
                        ></v-checkbox>

                        <v-checkbox
                          v-if="policy_agree_false_text || policy_agree_true_text"
                          class="shrink mt-0 mb-0 checksize ml-2 text-right poppins"
                          v-model="policy_accepted"
                          :label="policyCheckboxLabel"
                        ></v-checkbox>
                        <p
                          v-if="policyHtmlContent"
                          class="ml-2 mt-0 pr-1 policy-content"
                          v-html="policyHtmlContent"
                        ></p>
                      </div>
                      <div v-else class="trade-background">
                        <v-progress-linear
                          indeterminate
                          color="rgb(245, 159, 38)"
                        ></v-progress-linear>
                        <div class="mt-12 mb-12 text-h5">
                          Logging in please be patient..
                          <v-progress-circular
                            :width="3"
                            color="rgb(245, 159, 38)"
                            indeterminate
                          ></v-progress-circular>
                        </div>

                        <v-progress-linear
                          indeterminate
                          color="rgb(245, 159, 38)"
                        ></v-progress-linear>
                      </div>

                      <template v-if="false" class="text-center">
                        <v-snackbar
                          v-model="login_error"
                          :timeout="4000"
                          centered
                          color="red lighten-1"
                          shaped
                        >
                          <h3 class="text-center pa-2 black--text lighten-2">
                            Incorrect username or password.
                          </h3>
                          <!-- /.caption -->
                        </v-snackbar>
                      </template>
                    </div>
                  </form>
                </div>
              </div>
              <div v-else class="mr-12 mt-5">
                <browser_compat_box />
              </div>
            </v-col>
            <v-col cols="12" lg="5" md="7" class="">
              <template v-if="article !== 'error'">
                <template v-if="article.Title" class="pa-2 ma-2">
                  <h1 v-if="article.Title" class="orange-line font-italics">
                    {{ article.Title }}
                  </h1>

                  <p class="orange-line font-italic">{{ article.Headline }}</p>
                  <p class="top-line">
                    {{ article.p1 }}
                  </p>
                  <p class="top-line">
                    {{ article.p2 }}
                  </p>

                  <p class="top-line">{{ article.p3 }}</p>

                  <a :href="article['readMoreLink']" class="white--text" target="_blank"
                    >Read more</a
                  >
                </template>
              </template>
            </v-col>
            <!--            <v-col align="center">-->
            <!--               <v-img class="ml-4 ml-sm-12" src="../../assets/img/half-X01-1.png" width="200"></v-img>-->
            <!--            </v-col>-->
          </v-row>
        </v-col>
      </v-row>

      <v-row class="mt-6" align="center" justify="center">
        <v-col cols="1" sm="1" md="1"></v-col>
        <v-col>
          <div class="login-page-content yellow--text" v-html="loginPageContent"></div>
        </v-col>
        <v-col cols="1" sm="1" md="1"></v-col>
      </v-row>

      <applcation_selector
        :select_application_open.sync="$store.state.app.application_selector_open"
      />
    </v-container>
  </v-main>
</template>

<script>
import login from '@/components/application-level/mixins/login';
import browser_compat_box from '@/components/application-level/js_functions/browser_compat_box.vue';
import applcation_selector from '@/components/application-level/application-selector/applcation_selector.vue';

export default {
  mixins: [login],
  components: {browser_compat_box, applcation_selector},
  mounted() {
    this.login_started = false;
    this.policy_accepted = this.getCookie('policy_accepted') === 'true';
    const referrer = this.$route.query.referrer || 'trade-advisory';
    this.loadLoginPageContent(referrer).then(content => {
      this.loginPageContent = content;
    });
  },
  methods: {
    start_login_process_local() {
      this.login_started = true;
      this.start_login_process().then(v => (this.login_started = v));
    },
  },
  data() {
    return {
      login_started: false,
    };
  },
};
</script>

<style scoped>
*:focus {
  outline: none;
}

body {
  font-family: 'Poppins', serif;
  background-color: #181818;
  padding: 50px;
}

p {
  font-family: 'Poppins', serif;
}

.trade-background {
  background: #181818;
}

.orange-line {
  font-family: 'Poppins', serif;
  font-weight: 800;
  margin: 0;
  letter-spacing: 1px;
  color: #f59f26;
}

.top-line {
  line-height: 40px;
  letter-spacing: -1px;
  color: #a6a6a6;
  font-family: 'Poppins', serif;
  font-weight: 600;
}

.poppins {
  font-family: 'Poppins', serif;
}

.login {
  width: 300px;
}

.login-screen {
  background-color: #a6a6a6;
  border-radius: 5px;
  margin-top: 50px;
}

.login-form {
  text-align: center;
}

.control-group {
  margin-bottom: 10px;
}

input {
  text-align: center;
  background-color: #dfe3e4 !important;
  border: 2px solid transparent;
  border-radius: 3px;
  font-size: 16px;
  font-weight: 200;
  padding: 10px 0;
  width: 280px;
  transition: border 0.5s;
}

input:focus {
  border: 2px solid #3498db !important;
  box-shadow: none;
}

.btn {
  border: 2px solid transparent;
  background: #991b1e;
  color: white;
  font-size: 16px;
  line-height: 25px;
  padding: 10px 0;
  text-decoration: none;
  text-shadow: none;
  border-radius: 3px;
  box-shadow: none;
  transition: 0.25s;
  display: block;
  width: 280px;
  margin: 0 auto;
}

.btn:hover {
  background-color: #1f3c5f;
}

.checksize {
  transform: scale(1);
  padding-left: 0;
  margin-left: 0;
}

.login_img {
  width: 200px;
  height: auto;
}

.orange_text {
  color: rgb(245, 159, 38);
}

.swal2-title {
  font-family: monospace !important;
  color: red !important;
}

.policy-content {
  letter-spacing: -0.5px;
  color: #424242;
  font-family: 'Poppins', serif;
  font-weight: 550;
  font-size: 14px;
  text-align: left;
  line-height: 1.8;

}

.policy-content >>> p {

}

.checksize >>> .v-label {
  font-size: 12px;
}
</style>
